import { Component, OnInit } from '@angular/core';
import axios from 'axios';
import { environment } from '../../../environments/environment';
import { ToastService } from '../../services/toast.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-jumpers',
  templateUrl: './jumpers.component.html',
  styleUrls: ['./jumpers.component.scss']
})
export class JumpersComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
  loading = false;
  modal = {
    active: false,
    data: {}
  };
  userBase;
  selectedBase;
  bases = [];
  userIsSysAdmin = false;
  jumpers = [];
  activeJumpers = [];
  inactiveJumpers = [];
  selectedActive = {
    name: 'Active Jumpers',
    value: 'active'
  };
  headings = [
    {
      label: 'Name',
      key: 'name'
    },
    {
      label: 'Phone #',
      key: 'phoneNumber'
    },
    {
      label: 'Active',
      key: 'active'
    }
  ];
  settings = {
    route: 'jumpers',
    label: 'New Jumper',
    action: 'create',
    target: 'jumper'
  };

  constructor(private toast: ToastService, private router: Router) {}

  ngOnInit() {
    let jumpersType = window.sessionStorage.getItem('jumpersType');
    if (jumpersType === 'inactive') {
      this.selectedActive = {
        name: 'Inactive Jumpers',
        value: 'inactive'
      };
    } else {
      this.selectedActive = {
        name: 'Active Jumpers',
        value: 'active'
      };
    }

    if (this.userInfo.role == 'sysadmin') {
      this.userIsSysAdmin = true;
    }

    axios
    .get(environment.API_URL + '/base/dropdown/main', {
      headers: { Authorization: 'Bearer ' + this.token }
    })
    .then((response) => {
      this.bases = response.data;

      this.bases.forEach((base) => {
        base.name = base.text + ' | ' + base.baseCode;
        base.value = base.baseId;

        if (base.baseCode === this.userInfo.baseCode) {
          this.selectedBase = base;
          this.refreshJumpers();
        }
      });
    })
    .catch((error) => {
      console.dir(error);
    });

    this.userBase = this.userInfo.basecode;
  }

  selectHomeBase(selectedBase) {
    this.selectedBase = selectedBase;
    this.refreshJumpers();
  }

  sort = (array, key) => {
    array.sort((a, b) => {
      var keyA = a[key];
      var keyB = b[key];
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });
    return array;
  };

  reverseSort = (array, key) => {
    array.sort((a, b) => {
      var keyA = a[key];
      var keyB = b[key];
      if (keyA < keyB) {
        return 1;
      }
      if (keyA > keyB) {
        return -1;
      }
      return 0;
    });
    return array;
  };

  modalConfirmed = (data) => {
    if (data.action === 'delete') {
      this.delete(data.jumper);
    }
    this.modal.active = false;
  };
  modalDenied = (data) => {
    this.modal.active = false;
  };

  confirmDelete = (jumper) => {
    this.modal = {
      data: {
        content: 'Are you sure you want to delete this jumper?',
        deny: 'Cancel',
        confirm: 'Delete',
        action: 'delete',
        jumper: jumper
      },
      active: true
    };
  };

  delete = async (row) => {
    let id = '';
    if (row.id) {
      id = row.id;
    } else if (row.href) {
      id = row.href.slice(row.href.lastIndexOf('/') + 1, row.href.length);
    }
    let deleted = await axios
      .delete(environment.API_URL + '/jumpers/' + id + '/delete', {
        headers: { Authorization: 'Bearer ' + this.token }
      })
      .then((response) => {
        this.toast.show('Deleted Jumper', 'success');
        this.refreshJumpers();
      })
      .catch((error) => {
        this.toast.showFullError('Error deleting jumper', error);
      });
  };

  refreshJumpers = () => {
    this.loading = true;
    let baseId = this.selectedBase.baseId;
    let jumpers = [];
    this.activeJumpers = [];
    this.inactiveJumpers = [];

    axios
      .get(environment.API_URL + '/jumpers?baseId=' + baseId, {
        headers: { Authorization: 'Bearer ' + this.token }
      })
      .then((response) => {
        jumpers = response.data.value;
        jumpers.forEach((jumper) => {
          jumper.name = jumper.lastName + ', ' + jumper.firstName;
          jumper.active = jumper.activeStatus ? 'Yes' : 'No';
        });
        jumpers = this.sort(jumpers, 'name');
        jumpers = this.reverseSort(jumpers, 'active');
        jumpers.forEach((jumper) => {
          if (!jumper.activeStatus) {
            this.inactiveJumpers.push(jumper);
          } else {
            this.activeJumpers.push(jumper);
          }
        });
        if (this.selectedActive.value === 'active') {
          this.jumpers = this.activeJumpers;
        } else {
          this.jumpers = this.inactiveJumpers;
        }
        this.loading = false;
      })
      .catch((error) => {
        this.toast.showFullError('Unable to retreive jumpers list.', error);
        this.loading = false;
      });
  };

  selectActive = (event) => {
    window.sessionStorage.setItem('jumpersType', event.value);
    this.selectedActive = event;
    this.refreshJumpers();
  };
}
